const host = 'youvr';
// let domain;

const utils = {
  title: 'Pivo - Dashboard',
};

const config = {
  API2_URL: `https://api2.${host}.io`,
  APP_DOMAIN: 'http://app.getpivo.com/',
};

utils.config = config;

export default utils;
